// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39628385","455":"737851a4","488":"3ac20a5a","977":"8ce3a378"}[chunkId] + ".chunk.js";
};